import { Nav } from "@/components/Nav";
import { Seo } from "@/components/Seo";
import { Footer } from "@/components/Footer";
import { FadeUp, SectionHeading } from "@/components/Reveal";
import { CONTACT, waLink } from "@/data/content";

const SECTIONS = [
  {
    title: "Privacy",
    body: [
      "We collect only what we need to serve you: your name and email when you request a free guide, make an enquiry, join the community or make a purchase, and your booking details when you schedule a consultation. Payment card details are handled entirely by Paystack — we never see or store them.",
      "Free-guide downloads ask for your email with a separate, optional marketing-consent checkbox. We use your details to deliver what you asked for and — only with your consent — to send occasional JÀWÀ updates. We do not sell or share your personal data with third parties for their marketing.",
      "You can ask us to correct or delete your details at any time via the contact options below.",
    ],
  },
  {
    title: "Terms of service",
    body: [
      "JÀWÀ AFRICA provides travel, lifestyle, relocation and investment-orientation content, digital guides, memberships, consultations and concierge coordination. Our guides and consultations provide practical orientation based on research and experience — they are not regulated legal, financial, immigration or investment advice, and decisions remain yours.",
      "Prices are shown in your chosen display currency; checkout charges are made in Nigerian naira (₦) via Paystack at the amount disclosed before you pay. Supplier-dependent services (transport, stays, experiences, VIP arrival products) are confirmed — availability, inclusions and total price — before any payment is taken.",
      "Nothing on this website guarantees investment returns, property outcomes, visa or immigration approvals, event admission or third-party availability.",
    ],
  },
  {
    title: "Cookies",
    body: [
      "This site uses only the essentials: your browser's local storage to remember your display-currency choice, your member sign-in token and your cookie preference itself. We do not run advertising trackers.",
    ],
  },
  {
    title: "Payments, refunds and delivery",
    body: [
      "Digital guides are delivered instantly after verified payment (download link on the confirmation page and by email). If a guide's final edition is still being finalised at the time of purchase, your payment is confirmed and the guide is emailed to you as soon as it is ready.",
      "Consultation bookings are confirmed by email with your meeting link; a reminder is sent the day before. To rearrange, reply to your confirmation or WhatsApp us — at least 24 hours before your slot, as bookings inside 24 hours cannot be rescheduled online.",
      "Because digital guides are delivered immediately, they are generally non-refundable once downloaded; if anything goes wrong with payment or delivery, contact us and we will make it right. Supplier-dependent services follow the cancellation terms confirmed in your individual quote.",
    ],
  },
];

export default function LegalPage() {
  return (
    <div className="bg-jawa-ivory" data-testid="legal-page">
      <Nav />
      <Seo
        title="Privacy, Terms & Policies | JÀWÀ Africa"
        description="JÀWÀ Africa's privacy, terms, cookie, payment, refund and digital delivery policies — in plain language."
      />
      <main className="mx-auto max-w-3xl px-6 pb-24 pt-32 lg:pt-40">
        <FadeUp>
          <SectionHeading overline="The fine print, in plain language" title="Privacy, terms & policies." />
          <p className="mt-6 text-base leading-relaxed text-jawa-espresso/70">
            Last updated October 2026. Questions about any of this? Email {CONTACT.email} or{" "}
            <a href={waLink("Hello JÀWÀ — I have a question about your policies.")} target="_blank" rel="noopener noreferrer" className="text-jawa-turquoise underline">WhatsApp us</a>.
          </p>
        </FadeUp>
        <div className="mt-12 space-y-10">
          {SECTIONS.map((s) => (
            <FadeUp key={s.title}>
              <section data-testid={`legal-${s.title.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}>
                <h2 className="font-serif text-2xl font-medium text-jawa-espresso">{s.title}</h2>
                <div className="mt-3 space-y-3 text-sm leading-relaxed text-jawa-espresso/70">
                  {s.body.map((p, i) => (
                    <p key={i}>{p}</p>
                  ))}
                </div>
              </section>
            </FadeUp>
          ))}
        </div>
      </main>
      <Footer />
    </div>
  );
}
